import { Navigate } from 'react-router';
import { useHasPermission, useIsTenantAdmin } from '@/hooks/usePermissions';
import type { Permission } from '@jerico/shared';
import type { ReactNode } from 'react';

interface RequirePermissionProps {
  permission?: Permission;
  requireTenantAdmin?: boolean;
  children: ReactNode;
}

export function RequirePermission({ permission, requireTenantAdmin, children }: RequirePermissionProps) {
  const hasPermission = useHasPermission(permission!);
  const isTenantAdmin = useIsTenantAdmin();

  if (requireTenantAdmin && !isTenantAdmin) {
    return <Navigate to="/app" replace />;
  }

  if (permission && !hasPermission) {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
